module.exports = __webpack_public_path__ + "img/bermuda2.086270a7.jpg";